import axios from 'axios'
import {
  orikamiDomain,
  clientManagementDomain,
  storageDomain,
} from '../urlConst/domainUrl'

const API_URL_ORDER = orikamiDomain + '/api/v2/order/search'
// const API_URL_ORDER = orikamiDomain + '/api/v1/order/search_2d_per_group'

const API_URL_ORDER_DETAIL = orikamiDomain + '/api/v1/order/ref'
const API_URL_ORDER_DETAIL_CONTACT =
  clientManagementDomain + '/api/v1/client/contact_detail'

const API_URL_ORDER_UPDATE_STATUS =
  orikamiDomain + '/api/v1/order/update_status'

// NO
const API_URL_ORDER_MEIDA = storageDomain + '/api/v1/order/download_media'
const API_URL_MEDIA_NAME = storageDomain + '/api/v1/order/media_name'
// const API_URL_ORDER_MEIDA =
//   'https://orikomi-quote-api.107.jp/api/v1/order/get_media'

const API_URL_DESTINATIONS = orikamiDomain + '/api/v1/destinations/read'

const API_URL_UPDATE_ORDER_DESTINATION =
  orikamiDomain + '/api/v1/order/update_destinations'

const API_URL_UPDATE_DISTRIBUTION_QUANTITY =
  orikamiDomain + '/api/v1/order/update_destination_quantity'

const API_URL_DELETE_DISTRIBUTION_DESTINATION =
  orikamiDomain + '/api/v1/order/delete_destinations'

const API_URL_CONFIRM_DISTRIBUTION_DESTINATION =
  orikamiDomain + '/api/v1/order/fixed_destinations'

const API_URL_SYNC_SET_DATA = orikamiDomain + '/api/v1/order/sync/set_data'
const API_URL_SYNC_SET_DATA_ORIKOMI =
  orikamiDomain + '/api/v1/order/set_product_name'
const API_URL_GET_ITEM_CSV = orikamiDomain + '/api/v1/order/items_csv'
const API_URL_DOWNLOAD_CSV_LIST =
  orikamiDomain + '/api/v1/order/store_list_csv/download'

// Get Order Sort/Search
// @GET
const getSearchOrder = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_ORDER, data, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}
const getItemCsv = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_GET_ITEM_CSV, data, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}
const getListCsv = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_DOWNLOAD_CSV_LIST, data, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}

// Get Order Detail
// @GET
const getOrderDetail = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_ORDER_DETAIL, data, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}

// Get Order Detail Contact
// @GET
const getOrderDetailContact = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_ORDER_DETAIL_CONTACT, data, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}

// Get Media Download
// @POST
const getOrderMedia = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_ORDER_MEIDA, data, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}
// Get Media Download
// @POST
const getMediaName = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_MEDIA_NAME, data, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}

// Update Order Status
// @POST
const updateOrderStatus = async (dataStatusChange, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(
    API_URL_ORDER_UPDATE_STATUS,
    dataStatusChange,
    config
  )

  const newToken = res.headers.authorization
  return { res, newToken }
}

// Get Distributions Area
// @GET
const getDestinationsArea = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_DESTINATIONS, null, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}

// Update Order Distribution
// @POST
const updateOrderDestination = async (dataUpdateOrderDestination, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(
    API_URL_UPDATE_ORDER_DESTINATION,
    dataUpdateOrderDestination,
    config
  )
  const newToken = res.headers.authorization
  return { res, newToken }
}

// Update Distribution Quantity
// @POST
const updateDistributionQuantity = async (dataQuantityChange, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(
    API_URL_UPDATE_DISTRIBUTION_QUANTITY,
    dataQuantityChange,
    config
  )
  const newToken = res.headers.authorization
  return { res, newToken }
}

// Update Delete Distribution Destination
// @POST
const deleteDistributionDestination = async (dataDelete, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(
    API_URL_DELETE_DISTRIBUTION_DESTINATION,
    dataDelete,
    config
  )
  const newToken = res.headers.authorization
  return { res, newToken }
}

// Confirm Distribution Destination
// @POST
const confirmDistributionDestination = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(
    API_URL_CONFIRM_DISTRIBUTION_DESTINATION,
    data,
    config
  )

  const newToken = res.headers.authorization
  return { res, newToken }
}

// =========================== Sync ===========================
// Update Sync
// @POST
const updateSyncData = async (dataSync, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_SYNC_SET_DATA, dataSync, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}

// @POST
const updateSyncDataOrikomi = async (dataSync, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  }

  const res = await axios.post(API_URL_SYNC_SET_DATA_ORIKOMI, dataSync, config)
  const newToken = res.headers.authorization
  return { res, newToken }
}

const orderService = {
  // getOrderStatus,
  getSearchOrder,
  getOrderDetail,
  getOrderDetailContact,
  getOrderMedia,
  getMediaName,
  updateOrderStatus,
  getDestinationsArea,
  updateOrderDestination,
  updateDistributionQuantity,
  deleteDistributionDestination,
  confirmDistributionDestination,
  updateSyncData,
  updateSyncDataOrikomi,
  getItemCsv,
  getListCsv,
}

export default orderService
